import {api} from './api';
import Config from '../common/config';

const loginUrl = `${Config.HOST}`;

export const loginApi = (params) => {
  return api.postLogin(loginUrl, params);
};
